module.exports = __webpack_public_path__ + "static/img/1014_phase_function_Paper_PointsHejduk_Prediction.9e23dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1014_phase_function_Paper_PointsHejduk_Prediction.png
// module id = FUc3
// module chunks = 0